import { Box, Typography } from '@mui/material'
import CountUp from 'react-countup'

const Stat = ({ total, title, icon }) => {
  return (
    <Box className="stat">
      <Typography align="center" variant="h3">
        <CountUp end={total} />
      </Typography>
      <Typography variant='subtitle4' align="center">{title}</Typography>
      {/* {icon && icon} */}
    </Box>
  )
}

export default Stat
